import React from 'react';
import range from 'lodash/range';
import styled from 'styled-components';
import ItemsCarousel from 'react-items-carousel';
import {Icon} from '@fluentui/react';
const noOfCards = 3;
//const autoPlayDelay = 2000;
const chevronWidth = 20;

const Wrapper = styled.div`
  padding: 0 ${chevronWidth}px;
  width: 480px;
  margin: 0 auto;
  margin-left: -10px;
`;

const SlideItem = styled.div`
  height: 100%;
  fontSize: 14px;
`;



export default class Carousel extends React.Component {
    state = {
        activeItemIndex: 0,
    };

    componentDidMount() {
      //  this.interval = setInterval(this.tick, autoPlayDelay);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    tick = () => this.setState(prevState => ({
        activeItemIndex: (prevState.activeItemIndex + 1) % (this.props.children.length -noOfCards + 1),
    }));

    onChange = value => this.setState({ activeItemIndex: value });

    render() {
        const numberOfItems = this.props.children.length;
        const carouselItems = range(numberOfItems).map(index => (
            <SlideItem key={index}>
                {this.props.children[index]}
            </SlideItem>
        ));

        return (
            <Wrapper>
                <ItemsCarousel
                    gutter={4}
                    showSlither ={true}
                    numberOfCards={noOfCards}
                    activeItemIndex={this.state.activeItemIndex}
                    requestToChangeActive={this.onChange}
                    rightChevron={<Icon style={{color:'rgb(0, 120, 212)', transform: 'rotate(180deg)'}} iconName="SkypeCircleArrow"/>}
                    leftChevron={<Icon style ={{color:'rgb(0, 120, 212)'}} iconName="SkypeCircleArrow"/>}
                    chevronWidth={chevronWidth}
                    outsideChevron
                    children={carouselItems}
                />
            </Wrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Carusele.js